<template>
	<div class="ingame-pending">
		<div class="ingame-pending__header">
			<div class="ingame-pending__header__title">
				{{ $t('checkout.pending-purchase') }}
			</div>
			<div class="ingame-pending__header__message">
				<template v-if="region !== 'global' || !isUseWallet">
					{{ $t('checkout.in-game-pending') }}
				</template>
				<template v-else>
					<div class="ingame-pending__header__message__1">{{ $t('checkout.in-game-pending-nx-1') }}</div>
					<div class="ingame-pending__header__message__2">{{ $t('checkout.in-game-pending-nx-2') }}</div>
					<div class="ingame-pending__header__message__3">{{ $t('checkout.in-game-pending-nx-3') }}</div>
				</template>
			</div>
		</div>

		<div v-if="orderNumber" class="ingame-pending__details">
			<div class="order-details">
				<div class="order-details__row">
					<div class="order-details__row__title">{{ $t('checkout.order-number') }}</div>
					<div class="order-details__row__value">{{ orderNumber }}</div>
				</div>
			</div>
		</div>

		<i18n class="ingame-pending__contacts" path="checkout.for-information-billing" tag="div">
			<template v-slot:nexonSupportCenter>
				<a :href="supportLink" target="_blank" @click="supportTracking">
					{{ $t('checkout.nexon-support-center') }}
				</a>
			</template>
		</i18n>

		<div class="ingame-pending__action">
			<FormButton class="btn-primary" :label="$t('checkout.close-window')" :button-click="close"></FormButton>
		</div>
	</div>
</template>

<script>
import { FormButton } from '@arena/toolkit';
import resultMixin from './result-mixin';

export default {
	name: 'InGamePurchasePending',
	components: {
		FormButton,
	},
	mixins: [resultMixin],
	computed: {
		isUseWallet() {
			return this.$store.state.accountBalance.isDisplayBalance;
		},
	},
};
</script>

<style lang="scss" scoped>
.ingame-pending {
	max-width: 640px;
	margin-left: auto;
	margin-right: auto;
	&__header {
		text-align: center;
		line-height: 1;
		padding-bottom: 16px;
		border-bottom: 2px solid rgba(#fff, 0.5);

		&:before {
			content: '';
			display: block;
			width: 100%;
			height: 100px;
			background-image: url('~@/images/purchase-complete.png');
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			margin-top: 40px;

			@media (max-width: 700px) {
				content: none;
			}
		}
		&__title {
			font-size: 24px;
			padding-top: 13px;
			color: #fff;
		}
		&__message {
			padding-top: 10px;
			line-height: 1.3;
			@media (max-width: 500px) {
				&__1,
				&__2,
				&__3 {
					display: inline;
				}
			}
		}
	}
	&__details {
		border-bottom: 1px solid rgba(#fff, 0.2);
		.order-details {
			padding-bottom: 14px;
			&__row {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				padding-top: 14px;
				line-height: 1.4;

				&__title,
				&__value {
					display: block;
					max-width: 100%;
				}
				&__title {
					margin-right: auto;
					padding-right: 15px;
				}
				&__value {
					color: #fff;
				}

				@media (max-width: 600px) {
					justify-content: start;
					&__title,
					&__value {
						flex: 0 0 100%;
						max-width: 100%;
					}
					&__value {
						word-break: break-word;
						word-wrap: break-word;
					}
				}
			}
		}
	}
	&__contacts {
		text-align: center;
		padding-top: 34px;
		line-height: 1.3;
		a {
			text-decoration: underline;
			text-underline-position: under;
			text-transform: capitalize;
			color: inherit;
			&:hover {
				color: #fff;
			}
		}
	}
	&__action {
		button {
			min-width: 320px;
			width: auto;
			margin-top: 35px;
			margin-left: auto;
			margin-right: auto;

			@media (max-width: 700px) {
				min-width: 100%;
				width: 100%;
			}
		}
	}
}
</style>
